// Mirrors the backend's ExchangeNewItemDiscountResolver: percentage of the
// item subtotal, or a flat value, clamped so it can never exceed the
// subtotal. This is a client-side ESTIMATE for immediate cashier feedback —
// the backend recomputes and is authoritative when the exchange is submitted.
export const computeDiscountAmount = (discountType, discountValue, modifiedValue, unitPrice, quantity) => {
  const effectiveValue = modifiedValue != null ? modifiedValue : parseFloat(discountValue || 0);
  const subtotal = parseFloat(unitPrice || 0) * parseFloat(quantity || 0);
  const raw = discountType === 'percentage' ? (subtotal * effectiveValue / 100) : effectiveValue;
  return Math.min(Math.round(raw * 100) / 100, subtotal);
};
